import React from 'react'
import Title from '../../../components/common/TitleFooter';
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom';

let useStyles = makeStyles((theme) => ({
    card: {
        width: '24%',
        padding: 10,
        padding: '20px 20px',
        "@media(max-width : 750px)": {
            width: '50%',
            flexWrap: 'wrap',
            textAlign: 'center'
        },
    },
    list: {
        listStyle: 'none',
        width: '100%',
        lineHeight: 2.4,
        '& > li': {
            width: '100%',
            margin: 'auto',
            textAlign: 'left',
            position: 'relative',
            whiteSpace: "nowrap",
            cursor: 'pointer',
            "@media(max-width : 750px)": {
                textAlign: 'center'
            },
        }
    },
    text: {
        fontSize: 13,
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            fontSize: 12,

        },
    },

}))

export default function Index({ data, BoldText }) {

    let classes = useStyles()

    return (
        <div className={classes['card']}>
            <div>
                <p className={`${BoldText}`}>
                    {data?.title}
                </p>
            </div>

            <ul className={classes['list']}>
                {
                    data?.list.map((data, index) => {
                        return (
                            <>
                                {
                                    data.action && (
                                        <li key={index} onClick={() => data?.action(data)}>
                                            {data.title}
                                        </li>
                                    )
                                }
                                {
                                    !data.action && (
                                        <li key={index}>
                                            {
                                                data.link && (
                                                    <a href={data.link} target='_blank' rel="noopener noreferrer">
                                                        <span className={classes['text']}>{data.title}</span>
                                                    </a>
                                                )
                                            }
                                            {
                                                !data.link && !data.linkRouter && (
                                                    <span className={classes['text']}>{data.title}</span>
                                                )
                                            }
                                            {
                                                data.linkRouter && (
                                                    <Link to={data.linkRouter}>
                                                        {data.title}
                                                    </Link>
                                                )
                                            }
                                        </li>
                                    )
                                }
                            </>

                        )
                    })
                }

            </ul>
        </div>
    )
}
